import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Renders a CTA button based on the button text configuration
 * @param {string} buttonText - The text to display on the button (from domain config)
 * @param {string} defaultText - Fallback text if buttonText is not provided
 * @param {string} buttonClasses - CSS classes to apply to the button
 * @param {string} shopLink - Optional shop link from domain config
 * @returns {JSX.Element} - Link or anchor element based on button text
 */
export const renderCtaButton = (buttonText, defaultText, buttonClasses, shopLink) => {
  const text = buttonText || defaultText;
  
  // Check if button text is "Check Prices" - route internally
  if (text === 'Check Prices') {
    return (
      <Link 
        to="/compare-prices"
        className={buttonClasses}
      >
        {text}
      </Link>
    );
  }
  
  // Check if button text is "Request Demo" or similar - route internally
  if (text === 'Request Demo' || text === 'Request a Demo') {
    return (
      <Link 
        to="/request-demo"
        className={buttonClasses}
      >
        {text}
      </Link>
    );
  }
  
  // Default to external shop link (use shopLink from config or fallback)
  return (
    <a 
      href={shopLink || "https://shop.fleethoster.com/"}
      target="_blank"
      rel="noopener noreferrer"
      className={buttonClasses}
    >
      {text}
    </a>
  );
};

